module.exports = __webpack_public_path__ + "img/wfd-logo.1da321bb.svg";